module.exports = __webpack_public_path__ + "img/globulo-filrouge.8efd697a.png";